module.exports = __webpack_public_path__ + "static/media/des-1.9a5ac66f.png";